var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "#FF5A5F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.75 39C77.75 60.4058 60.3995 77.75 39 77.75C17.6005 77.75 0.25 60.4058 0.25 39C0.25 17.6067 17.6005 0.25 39 0.25C60.3995 0.25 77.75 17.6067 77.75 39ZM39 46.8125C35.0305 46.8125 31.8125 50.0305 31.8125 54C31.8125 57.9695 35.0305 61.1875 39 61.1875C42.9695 61.1875 46.1875 57.9695 46.1875 54C46.1875 50.0305 42.9695 46.8125 39 46.8125ZM32.1761 20.9772L33.3352 42.2272C33.3894 43.2216 34.2116 44 35.2073 44H42.7927C43.7884 44 44.6106 43.2216 44.6648 42.2272L45.8239 20.9772C45.8825 19.9031 45.0273 19 43.9517 19H34.0481C32.9725 19 32.1175 19.9031 32.1761 20.9772Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0b58add0.svg";
export { ForwardRef as ReactComponent };